import { LitElement, html, css, unsafeCSS } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { icons } from '../../Icons.js';
import styles from './Overlay.js.css?raw';
export class RdOverlay extends LitElement {
  constructor() {
    super();
    this.open = true;
    this.showCloseButton = true;
    this.deleteOnClose = false;
    this.closeOnBackdropClick = true;
    this.isPage = true;
    this.addEventListener('click', (e) => {
      if (this.closeOnBackdropClick && e.target === this) {
        this.close(this.deleteOnClose);
      }
    });
  }
  static properties = {
    open: { type: Boolean, reflect: true },
    showCloseButton: { type: Boolean, reflect: true },
    deleteOnClose: { type: Boolean, reflect: true },
    closeOnBackdropClick: { type: Boolean, reflect: true },
    isPage: { type: Boolean, reflect: true },
  };

  close(deleteOnClose = false) {
    this.open = false;
    if (deleteOnClose) {
      this.remove();
    }
  }

  static styles = css`
    :host {
      position: relative;
      width: 0;
      overflow: visible;
      display: block;
      box-sizing: border-box;
      width: 0vw;
      height: 0vh;
      z-index: 9999999999999999999;
      pointer-events: none;
      background: transparent;
    }
    ${unsafeCSS(styles)}
  `;
  createRenderRoot() {
    return super.createRenderRoot();
  }
  get _inlineOverylayStyle() {
    let style = `
    
    `;
    return style;
  }

  render() {
    return html`<div class="overlay ${this.open ? '' : 'hidden'}" style="${this._inlineOverylayStyle}">
      <div class="${this.isPage ? 'page' : 'dialog'}" role="dialog" aria-modal="true" aria-hidden="${this.open ? 'false' : 'true'}" @click="${(e) => e.stopPropagation()}">
        <div class="header">
          <span class="close-button ${this.showCloseButton ? '' : 'hidden'}" @click=${() => this.close(this.deleteOnClose)}>${!this.isPage ? unsafeHTML(icons.xTimes) : unsafeHTML(icons.angleLeft)}</span>
          <div class="top-slot"><slot name="header">Something</slot></div>
        </div>
        <div class="body">
          <slot></slot>
        </div>
      </div>
    </div>`;
  }
}
if (!customElements.get('rd-overlay')) customElements.define('rd-overlay', RdOverlay);
